import { InlineLabelInput } from 'components/common';
import { useState } from 'react';
import { useTaskStore } from 'store/task';
import { TagsInput } from 'components/common/TagsInput/TagsInput';
import { TAG_MAX_LENGTH } from './constants';

export const QuestionValidator = () => {
  const {
    errors,
    draft: draftTask,
    actions: { setDraftQuestionAnswer },
  } = useTaskStore((state) => state);
  const [incorrectValueInput, setIncorrectValueInput] = useState('');
  const [correctAnswerInput, setCorrectAnswerInput] = useState('');

  const {
    validator,
    answers: { predefinedOptions },
    status,
  } = draftTask;

  if (validator !== 'PREDEFINED_OPTIONS' || !predefinedOptions) {
    return null;
  }

  const pushToQuestions = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      correctAnswerInput &&
      !predefinedOptions.answers
        .map((q) => q.title)
        .includes(correctAnswerInput) &&
      event.key === 'Enter' &&
      !predefinedOptions.answers.find((a) => a.isCorrect)
    ) {
      setDraftQuestionAnswer([
        ...draftTask.answers.predefinedOptions!.answers,
        {
          title: correctAnswerInput,
          isCorrect: true,
        },
      ]);
      setCorrectAnswerInput('');
    }

    if (
      incorrectValueInput &&
      !predefinedOptions.answers
        .map((q) => q.title)
        .includes(incorrectValueInput) &&
      event.key === 'Enter' &&
      predefinedOptions.answers.filter((a) => !a.isCorrect).length <=
        TAG_MAX_LENGTH
    ) {
      setDraftQuestionAnswer([
        ...draftTask.answers.predefinedOptions!.answers,
        {
          title: incorrectValueInput,
          isCorrect: false,
        },
      ]);
      setIncorrectValueInput('');
    }
  };

  const removeTag = (tag: string): void => {
    const filteredAnswers = predefinedOptions.answers.filter(
      (answer) => answer.title !== tag,
    );

    setDraftQuestionAnswer([...filteredAnswers]);
  };

  const isNotAvailableStatus =
    status === 'PENDING_APPROVAL' || status === 'APPROVED';

  return (
    <>
      <InlineLabelInput label="Correct answer">
        <TagsInput
          errorMessage={errors.predefinedOptionCorrectAnswer}
          inputValue={correctAnswerInput}
          isDisabled={isNotAvailableStatus}
          isOptionSelected={validator === 'PREDEFINED_OPTIONS'}
          maxAllowedTags={1}
          pushToList={pushToQuestions}
          removeItemFromList={removeTag}
          tagsList={
            predefinedOptions.answers
              .filter((q) => q.isCorrect)
              .map((q) => q.title) || []
          }
          updateInputValue={setCorrectAnswerInput}
        />
      </InlineLabelInput>
      <InlineLabelInput label="Incorrect answers">
        <TagsInput
          errorMessage={errors.predefinedOptionIncorrectAnswer}
          inputValue={incorrectValueInput}
          isDisabled={isNotAvailableStatus}
          isOptionSelected={validator === 'PREDEFINED_OPTIONS'}
          pushToList={pushToQuestions}
          removeItemFromList={removeTag}
          tagsList={
            predefinedOptions.answers
              .filter((q) => !q.isCorrect)
              .map((q) => q.title) || []
          }
          updateInputValue={setIncorrectValueInput}
        />
      </InlineLabelInput>
    </>
  );
};
